import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';
import Picker,{SKIN_TONE_NEUTRAL} from 'emoji-picker-react';

import { editContent } from '../../modules/editor';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { getSelection, replaceChar } from '../../util/selection';
import { getPathAfterBuild } from '../../util/file';

type Props = {
	target: string;
	value: string;
};

function EmojiPicker({ target, value }: Props) {
	const dispatch = useDispatch();
	const [range, setRange] = useState({} as any);

	const [open, setOpen] = useState(false);

	const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

	const toggleOpen = () => {
		setOpen(!open);
		try {
			const currentSelection = getSelection();
			const range = currentSelection.getRangeAt(0);		
			setRange(range);			
		} catch (error) {
			console.error(error);
		}
	}

	const onEmojiClick = (event:any, emojiObject:any) => {
		const { emoji } = emojiObject;

		if (range.collapsed) {
			let a = value.split('');
			a.splice(range.startOffset, 0, emoji);
			dispatch(editContent({ target: target, data: a.join('') }));
		} else {
			const nt = replaceChar(value, emoji, range.startOffset);			
			dispatch(editContent({ target: target, data: nt}));
		}

		setOpen(false);
	}

	const ref = useRef(null);
	useOnClickOutside(ref, (): any => {
		setOpen(false);
	});

	return (
		<div className="emoji-dropdown" ref={ref}>
			<button
				className={open ? 'btn active' : 'btn'}
				onClick={toggleOpen}
			>
				<ReactSVG src={iconImage(`./icon/toolbar/emoji.svg`)} width="10" />
			</button>
			{
				open && (
					<div className="emoji-dropdown-body">
						<Picker 
							onEmojiClick={onEmojiClick} 
							disableSkinTonePicker={true}
        			preload={true}
        			skinTone={SKIN_TONE_NEUTRAL}
						/>
					</div>
				)
			}
		</div>
	);
}

EmojiPicker.defaultProps = {
};

export default EmojiPicker;